import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  Chip,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Divider,
  Input,
} from "@nextui-org/react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faDownload, 
  faRefresh, 
  faUser,
  faShieldAlt,
  faInfoCircle,
  faCheckCircle,
  faTimesCircle,
  faClock,
  faCalendarAlt,
  faEye,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faSearch,
  faGripVertical,
  faTable
} from "@fortawesome/free-solid-svg-icons";
import { fetchAuditLogs, getAuditLogsWithFilter } from "../../controllers/APIController";
import LoadingPage from "../../components/Loader/LoadingPage";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import NullData from "../../components/ErrorPage/NullData";
import { StandardCloseButton } from "../../components/StandardButtons";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const AuditLogs = () => {
  const navigate = useNavigate();
  const { _orgId } = useParams();
const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedAuditEntry, setSelectedAuditEntry] = useState(null);
  const [auditData, setAuditData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [error, setError] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'timestamp', direction: 'desc' });
  const [layoutMode, setLayoutMode] = useState("table");
  const clientQuery= useQueryClient()

  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;
  const orgFilterUrl = "filters[Organization][id][$eqi]=" + OrgInfo;


  const { data: AuditData, isLoading } = useQuery({
    queryKey: ["Audit", orgFilterUrl],
    queryFn: () => getAuditLogsWithFilter(orgFilterUrl),
  });

  // const fetchAuditData = async () => {
  //   setIsLoading(true);
  //   setError(null);
    
  //   try {
  //     const data = await getAuditLogsWithFilter(orgFilterUrl);
      
    
  //   } catch (error) {
  //     console.error("Error fetching audit data:", error);
  //     setAuditData([]);
  //     setFilteredData([]);
  //     setError("Failed to load audit logs from backend. Please check your connection.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const getMockAuditData = () => {
    return [
      {
        id: "audit_001",
        attributes: {
          timestamp: "2024-01-15T14:30:00.123Z",
          userId: "user_001",
          username: "john.doe@company.com",
          userDisplayName: "John Doe",
          ipAddress: "192.168.1.100",
          action: "CREATE_METRIC",
          actionDescription: "Created new ESG metric for carbon emissions",
          resourceType: "METRIC",
          resourceId: "metric_001",
          resourceName: "Carbon Emissions",
          module: "Metrics Management",
          status: "SUCCESS",
          errorCode: null,
          errorMessage: null
        }
      },
      {
        id: "audit_002",
        attributes: {
          timestamp: "2024-01-15T14:25:15.456Z",
          userId: "user_002",
          username: "jane.smith@company.com",
          userDisplayName: "Jane Smith",
          ipAddress: "192.168.1.101",
          action: "UPDATE_FRAMEWORK",
          actionDescription: "Updated sustainability framework parameters",
          resourceType: "FRAMEWORK",
          resourceId: "framework_001",
          resourceName: "Sustainability Framework",
          module: "Framework Management",
          status: "SUCCESS",
          errorCode: null,
          errorMessage: null
        }
      },
      {
        id: "audit_003",
        attributes: {
          timestamp: "2024-01-15T14:20:30.789Z",
          userId: "user_001",
          username: "john.doe@company.com",
          userDisplayName: "John Doe",
          ipAddress: "192.168.1.100",
          action: "EXPORT_REPORT",
          actionDescription: "Exported quarterly sustainability report",
          resourceType: "REPORT",
          resourceId: "report_001",
          resourceName: "Q4 Sustainability Report",
          module: "Reporting",
          status: "SUCCESS",
          errorCode: null,
          errorMessage: null
        }
      },
      {
        id: "audit_004",
        attributes: {
          timestamp: "2024-01-15T10:15:00.012Z",
          userId: "user_003",
          username: "admin@company.com",
          userDisplayName: "System Admin",
          ipAddress: "192.168.1.102",
          action: "UPDATE_USER_ROLE",
          actionDescription: "Updated user role from Editor to Admin",
          resourceType: "USER",
          resourceId: "user_004",
          resourceName: "Sarah Johnson",
          module: "User Management",
          status: "SUCCESS",
          errorCode: null,
          errorMessage: null
        }
      },
      {
        id: "audit_005",
        attributes: {
          timestamp: "2024-01-15T10:10:30.345Z",
          userId: "user_002",
          username: "jane.smith@company.com",
          userDisplayName: "Jane Smith",
          ipAddress: "192.168.1.101",
          action: "DELETE_METRIC",
          actionDescription: "Attempted to delete metric without permission",
          resourceType: "METRIC",
          resourceId: "metric_002",
          resourceName: "Water Consumption",
          module: "Metrics Management",
          status: "FAILED",
          errorCode: "PERMISSION_DENIED",
          errorMessage: "User does not have permission to delete metrics"
        }
      }
    ];
  };

  useEffect(() => {
    if (AuditData && AuditData.length > 0) {
      setAuditData(AuditData);
      setFilteredData(AuditData);
      console.log("Successfully loaded audit logs from Strapi backend");
    } else {
      setAuditData([]);
      setFilteredData([]);
      console.log("No audit logs found in Strapi backend");
    }
  }, [AuditData]);

  useEffect(() => {
    applyFilters();
  }, [auditData, searchTerm, selectedUser, selectedAction, selectedStatus, selectedModule, dateRange]);

  const applyFilters = () => {
    let filtered = [...auditData];

    if (searchTerm) {
      filtered = filtered.filter(item => 
        item.attributes.userDisplayName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.attributes.action?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.attributes.actionDescription?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.attributes.resourceName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.attributes.module?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedUser) {
      filtered = filtered.filter(item => item.attributes.userId === selectedUser);
    }

    if (selectedAction) {
      filtered = filtered.filter(item => item.attributes.action === selectedAction);
    }

    if (selectedStatus) {
      filtered = filtered.filter(item => item.attributes.status === selectedStatus);
    }

    if (selectedModule) {
      filtered = filtered.filter(item => item.attributes.module === selectedModule);
    }

    if (dateRange.start) {
      filtered = filtered.filter(item => 
        new Date(item.attributes.timestamp) >= new Date(dateRange.start)
      );
    }
    if (dateRange.end) {
      filtered = filtered.filter(item => 
        new Date(item.attributes.timestamp) <= new Date(dateRange.end + "T23:59:59")
      );
    }

    setFilteredData(filtered);
  };

  const handleRefresh = async () => {
    clientQuery.invalidateQueries({ queryKey: ["Audit", orgFilterUrl] });
  };

  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return faSort;
    return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
  };

  const sortedData = useMemo(() => {
   return [...filteredData].sort((a, b) => {
      const aValue = a.attributes[sortConfig.key];
      const bValue = b.attributes[sortConfig.key];

      if (sortConfig.key === "timestamp") {
        return sortConfig.direction === "asc"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return 0;
    });
  }, [filteredData]);

  const handleExportData = async () => {
    setIsExporting(true);
    setError(null);
    
    try {
      const headers = [
        "Timestamp", "User", "Action", "Action Description", "Resource", 
        "Module", "Status", "IP Address", "Error Code", "Error Message"
      ];
      
      const csvContent = [
        headers.join(","),
        ...sortedData.map(item => [
          `"${new Date(item.attributes.timestamp).toLocaleString()}"`,
          `"${item.attributes.userDisplayName || item.attributes.username}"`,
          `"${item.attributes.action}"`,
          `"${item.attributes.actionDescription}"`,
          `"${item.attributes.resourceName}"`,
          `"${item.attributes.module}"`,
          `"${item.attributes.status}"`,
          `"${item.attributes.ipAddress}"`,
          `"${item.attributes.errorCode || ""}"`,
          `"${item.attributes.errorMessage || ""}"`
        ].join(","))
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `audit-logs-${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Export error:", error);
      setError("Failed to export data. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  const handleViewDetails = (auditEntry) => {
    setSelectedAuditEntry(auditEntry);
    onOpen();
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'SUCCESS': return 'success';
      case 'FAILED': return 'danger';
      case 'PENDING': return 'warning';
      default: return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'SUCCESS': return faCheckCircle;
      case 'FAILED': return faTimesCircle;
      case 'PENDING': return faClock;
      default: return faInfoCircle;
    }
  };

  const getUniqueValues = (field) => {
    const values = [...new Set(auditData.map(item => item.attributes[field]).filter(Boolean))];
    return values.sort();
  };

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleString();
  };

  const getSummaryStats = () => {
    const total = auditData.length;
    const success = auditData.filter(item => item.attributes.status === 'SUCCESS').length;
    const failed = auditData.filter(item => item.attributes.status === 'FAILED').length;
    const uniqueUsers = new Set(auditData.map(item => item.attributes.userId)).size;
    
    return { total, success, failed, uniqueUsers };
  };

  const stats = getSummaryStats();

  // Get current timestamp
  const getCurrentTimestamp = () => {
    const now = new Date();
    const time = now.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true 
    });
    const date = now.toLocaleDateString('en-US', { 
      weekday: 'long', 
      month: 'long', 
      day: 'numeric', 
      year: 'numeric' 
    });
    return `${time} • ${date}`;
  };

  if (isLoading) {
    return <LoadingPage loadingText="Loading audit logs..." />;
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Page Header */}
      <div className="bg-white px-8 py-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-start justify-between">
            <div>
              <h1 className="text-3xl font-bold text-slate-900">Audit Logs</h1>
              <p className="text-slate-600 mt-2 text-lg">Track and monitor all user actions and system events</p>
            </div>
            <div className="text-right">
              <div className="text-slate-600 font-medium">{getCurrentTimestamp()}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Breadcrumbs */}
      <div className="max-w-7xl mx-auto px-8 py-2">
        <BreadCrumbsPage />
      </div>

      {/* Control Bar */}
      <div className="max-w-7xl mx-auto px-8 py-4">
        <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4">
          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
            <div className="flex-1">
              <Input
                placeholder="Search audit logs by name, description, or category..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                startContent={<FontAwesomeIcon icon={faSearch} className="text-slate-400" />}
                className="max-w-md"
                size="sm"
                variant="bordered"
              />
            </div>
            
            <div className="flex items-center gap-3">
              {/* Layout Toggle */}
              <div className="flex bg-slate-100 rounded-lg p-1">
                <Button
                  size="sm"
                  variant={layoutMode === "cards" ? "solid" : "light"}
                  color={layoutMode === "cards" ? "success" : "default"}
                  onClick={() => setLayoutMode("cards")}
                  className="px-3 py-1 text-xs"
                >
                  <FontAwesomeIcon icon={faGripVertical} className="w-3 h-3 mr-1" />
                  Cards
                </Button>
                <Button
                  size="sm"
                  variant={layoutMode === "table" ? "solid" : "light"}
                  color={layoutMode === "table" ? "success" : "default"}
                  onClick={() => setLayoutMode("table")}
                  className="px-3 py-1 text-xs"
                >
                  <FontAwesomeIcon icon={faTable} className="w-3 h-3 mr-1" />
                  Table
                </Button>
              </div>

              {/* Refresh Button */}
              <Button
                variant="flat"
                startContent={<FontAwesomeIcon icon={faRefresh} />}
                onClick={handleRefresh}
                className="bg-white border border-slate-200 text-slate-700 hover:bg-slate-50"
                size="sm"
              >
                Refresh
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-8 py-4">
        {/* Error Display */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2">
              <FontAwesomeIcon icon={faTimesCircle} className="text-red-500" />
              <span className="text-red-800">{error}</span>
            </div>
          </div>
        )}

        {/* Content Display */}
        {layoutMode === "cards" ? (
          <div className="space-y-4">
            {filteredData.length > 0 ? (
              filteredData.map((item) => (
                <Card key={item.id} className="border border-slate-200 shadow-sm">
                  <CardBody className="p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-slate-900 mb-2">
                          {item.attributes.action}
                        </h3>
                        <p className="text-slate-600 mb-3">
                          {item.attributes.actionDescription}
                        </p>
                        <div className="flex items-center gap-4 text-sm text-slate-500">
                          <span className="flex items-center gap-2">
                            <FontAwesomeIcon icon={faUser} />
                            {item.attributes.userDisplayName || item.attributes.username}
                          </span>
                          <span className="flex items-center gap-2">
                            <FontAwesomeIcon icon={faCalendarAlt} />
                            {formatTimestamp(item.attributes.timestamp)}
                          </span>
                          <span className="flex items-center gap-2">
                            <FontAwesomeIcon icon={faShieldAlt} />
                            {item.attributes.module}
                          </span>
                        </div>
                      </div>
                      <div className="text-right">
                        <Chip
                          color={getStatusColor(item.attributes.status)}
                          variant="flat"
                          size="lg"
                          startContent={<FontAwesomeIcon icon={getStatusIcon(item.attributes.status)} />}
                          className="mb-2"
                        >
                          {item.attributes.status}
                        </Chip>
                        <Button
                          size="sm"
                          variant="light"
                          onPress={() => handleViewDetails(item)}
                          startContent={<FontAwesomeIcon icon={faEye} />}
                        >
                          View Details
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              ))
            ) : (
              <NullData 
                title="No Audit Logs Found"
                description="No audit logs match your current filters. Try adjusting your search criteria."
                icon="📊"
              />
            )}
          </div>
        ) : (
          <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-6">
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-slate-900">Audit Logs Table</h3>
              <p className="text-slate-600">Detailed view of all audit entries</p>
            </div>

            {/* Results Count */}
            <div className="flex items-center justify-between mb-4">
              <p className="text-slate-600">
                Showing {filteredData.length} of {auditData.length} audit entries
              </p>
              <Button
                color="success"
                variant="flat"
                size="sm"
                startContent={<FontAwesomeIcon icon={faDownload} />}
                onPress={handleExportData}
                isLoading={isExporting}
              >
                Export
              </Button>
            </div>

            {/* Audit Logs Table */}
            {filteredData.length > 0 ? (
              <Table
                removeWrapper
                aria-label="Audit logs table"
                isStriped={true}
                classNames={{
                  th: "bg-slate-50 text-slate-700 font-semibold text-xs border-b border-slate-100 py-3",
                  td: "py-3 border-b border-slate-100 text-sm"
                }}
              >
                <TableHeader>
                  <TableColumn>
                    <div className="flex items-center gap-2">
                      <span>Timestamp</span>
                      <Button
                        isIconOnly
                        size="sm"
                        variant="light"
                        onPress={() => handleSort('timestamp')}
                      >
                        <FontAwesomeIcon 
                          icon={getSortIcon('timestamp')} 
                          className="text-slate-400"
                        />
                      </Button>
                    </div>
                  </TableColumn>
                  <TableColumn>User</TableColumn>
                  <TableColumn>
                    <div className="flex items-center gap-2">
                      <span>Action</span>
                      <Button
                        isIconOnly
                        size="sm"
                        variant="light"
                        onPress={() => handleSort('action')}
                      >
                        <FontAwesomeIcon 
                          icon={getSortIcon('action')} 
                          className="text-slate-400"
                        />
                      </Button>
                    </div>
                  </TableColumn>
                  <TableColumn>Resource</TableColumn>
                  <TableColumn>Module</TableColumn>
                  <TableColumn>
                    <div className="flex items-center gap-2">
                      <span>Status</span>
                      <Button
                        isIconOnly
                        size="sm"
                        variant="light"
                        onPress={() => handleSort('status')}
                      >
                        <FontAwesomeIcon 
                          icon={getSortIcon('status')} 
                          className="text-slate-400"
                        />
                      </Button>
                    </div>
                  </TableColumn>
                  <TableColumn>Details</TableColumn>
                </TableHeader>
                <TableBody emptyContent={<NullData />}>
                  {sortedData.map((item) => (
                    <TableRow
                      key={item.id}
                      className="cursor-pointer hover:bg-slate-50"
                    >
                      <TableCell className="font-medium text-slate-700">
                        <div className="flex items-center gap-2">
                          <FontAwesomeIcon icon={faCalendarAlt} className="text-slate-400" />
                          <span className="text-sm">{formatTimestamp(item.attributes.timestamp)}</span>
                        </div>
                      </TableCell>
                      <TableCell className="font-medium text-slate-700">
                        <div className="flex items-center gap-2">
                          <FontAwesomeIcon icon={faUser} className="text-slate-400" />
                          <span>
                            {item.attributes.userDisplayName || item.attributes.username}
                          </span>
                        </div>
                      </TableCell>
                      <TableCell>
                        <Chip
                          color="default"
                          variant="flat"
                          size="sm"
                          className="font-medium"
                        >
                          {item.attributes.action}
                        </Chip>
                      </TableCell>
                      <TableCell className="text-slate-600">
                        {item.attributes.resourceName}
                      </TableCell>
                      <TableCell className="text-slate-600">
                        {item.attributes.module}
                      </TableCell>
                      <TableCell>
                        <Chip
                          color={getStatusColor(item.attributes.status)}
                          variant="flat"
                          size="sm"
                          startContent={<FontAwesomeIcon icon={getStatusIcon(item.attributes.status)} />}
                          className="font-medium"
                        >
                          {item.attributes.status}
                        </Chip>
                      </TableCell>
                      <TableCell>
                        <Button
                          isIconOnly
                          size="sm"
                          variant="light"
                          onPress={() => handleViewDetails(item)}
                        >
                          <FontAwesomeIcon icon={faEye} className="text-slate-500" />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <NullData 
                title="No Audit Logs Found"
                description="No audit logs match your current filters. Try adjusting your search criteria."
                icon="📊"
              />
            )}
          </div>
        )}
      </div>

      {/* Audit Entry Details Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="2xl" scrollBehavior="inside">
        <ModalContent>
          <ModalHeader className="flex flex-col gap-1">
            <h3 className="text-lg font-semibold">Audit Entry Details</h3>
            <p className="text-sm text-gray-600">
              Detailed information about this audit event
            </p>
          </ModalHeader>
          <ModalBody>
            {selectedAuditEntry && (
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Basic Information</h4>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Event ID:</span>
                        <span className="font-mono">{selectedAuditEntry.id}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Timestamp:</span>
                        <span>{formatTimestamp(selectedAuditEntry.attributes.timestamp)}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Status:</span>
                        <Chip
                          color={getStatusColor(selectedAuditEntry.attributes.status)}
                          variant="flat"
                          size="sm"
                          startContent={<FontAwesomeIcon icon={getStatusIcon(selectedAuditEntry.attributes.status)} />}
                        >
                          {selectedAuditEntry.attributes.status}
                        </Chip>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">User Information</h4>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span className="text-gray-600">User ID:</span>
                        <span className="font-mono">{selectedAuditEntry.attributes.userId}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Username:</span>
                        <span>{selectedAuditEntry.attributes.username}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Display Name:</span>
                        <span>{selectedAuditEntry.attributes.userDisplayName}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">IP Address:</span>
                        <span className="font-mono">{selectedAuditEntry.attributes.ipAddress}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <Divider />

                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Action Details</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Action:</span>
                      <Chip color="default" variant="flat" size="sm">
                        {selectedAuditEntry.attributes.action}
                      </Chip>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Description:</span>
                      <span className="text-right max-w-xs">{selectedAuditEntry.attributes.actionDescription}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Resource Type:</span>
                      <span>{selectedAuditEntry.attributes.resourceType}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Resource Name:</span>
                      <span>{selectedAuditEntry.attributes.resourceName}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Module:</span>
                      <span>{selectedAuditEntry.attributes.module}</span>
                    </div>
                  </div>
                </div>

                {selectedAuditEntry.attributes.errorCode && (
                  <>
                    <Divider />
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">Error Information</h4>
                      <div className="space-y-2 text-sm">
                        <div className="flex justify-between">
                          <span className="text-gray-600">Error Code:</span>
                          <span className="font-mono text-red-600">{selectedAuditEntry.attributes.errorCode}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600">Error Message:</span>
                          <span className="text-right max-w-xs text-red-600">{selectedAuditEntry.attributes.errorMessage}</span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <StandardCloseButton onPress={onClose}>
              Close
            </StandardCloseButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default AuditLogs; 